import {mapActions, mapGetters} from "vuex";

export default {
    mounted() {
        this.$root.showOverlay = true
        let date = new Date()
        date.toISOString().slice(0, 10)
        this
            .fetchOfficialCurrencyRates(date)
            .then(() => {
                this.isRatesReceived = true
                this.$root.showOverlay = false
        })
    },
    data() {
        return {
            isRatesReceived: false
        }
    },
    computed: mapGetters([
        'getCurrencyByShortName',
        'getUserCompany',
        'getCompanyCurrencyRateByShortName',
        'getOfficialCurrencyRateByShortName',
        'getUser',
        'isAuthenticated'
    ]),
    methods: {
        ...mapActions([
            'fetchUser',
            'fetchCompanyCurrencyRates',
            'fetchOfficialCurrencyRates'
        ]),
        calculateAmountByBaseCurrency(amount, fromCurrencyShortName, toCurrencyShortName) {
            if (fromCurrencyShortName === toCurrencyShortName) {
                return parseFloat(parseFloat(amount).toFixed(2))
            } else {
                return parseFloat((amount * this.getCompanyOrOfficialRate(fromCurrencyShortName).rate / this.getCompanyOrOfficialRate(toCurrencyShortName).rate).toFixed(2))
            }
        },
        calculateAmountToUZS(amount, fromCurrencyShortName) {
            if (fromCurrencyShortName === 'UZS') {
                return amount
            } else {
                return parseFloat((amount * this.getCompanyOrOfficialRate(fromCurrencyShortName).rate / this.getCompanyOrOfficialRate('UZS').rate).toFixed(2))
            }
        },
        getCompanyOrOfficialRate(shortname, isCompany = false, isOfficial = false, l = 12) {
            let baseCurrency = this.getUserCompany.baseCurrency ? this.getUserCompany.baseCurrency : this.getCurrencyByShortName('UZS')
            let currencyRate = null
            let currencyCompanyRate = null
            let currencyOfficialRate = null

            if (shortname === baseCurrency.shortName) {
                return {
                    rate: 1.0,
                    range: 0.0
                }
            }

            if (
                (shortname === 'RUB' && baseCurrency.shortName === 'USD') ||
                (shortname === 'USD' && baseCurrency.shortName === 'RUB')
            ) {
                currencyCompanyRate = this.getCompanyCurrencyRateByShortName("USD", "RUB")
                currencyOfficialRate = this.getOfficialCurrencyRateByShortName("USD", "RUB")

                if (!isCompany && !isOfficial) {
                    currencyRate = currencyCompanyRate ? currencyCompanyRate : currencyOfficialRate
                } else if (isCompany) {
                    currencyRate = currencyCompanyRate
                } else if (isOfficial) {
                    currencyRate = currencyOfficialRate
                }

                return {
                    rate: currencyRate ? (shortname === "RUB" ? (1 / currencyRate.rate).toFixed(l) : parseFloat(currencyRate.rate).toFixed(l)) : null,
                    range: currencyRate ? (shortname === "RUB" ? (-currencyRate.difference / (currencyRate.rate * (currencyRate.rate - currencyRate.difference))).toFixed(8) : parseFloat(currencyRate.difference).toFixed(l)) : null
                }
            } else {
                currencyCompanyRate = this.getCompanyCurrencyRateByShortName(shortname === "UZS" ? baseCurrency.shortName : shortname, "UZS")
                currencyOfficialRate = this.getOfficialCurrencyRateByShortName(shortname === "UZS" ? baseCurrency.shortName : shortname, "UZS")

                if (!isCompany && !isOfficial) {
                    currencyRate = currencyCompanyRate ? currencyCompanyRate : currencyOfficialRate
                } else if (isCompany) {
                    currencyRate = currencyCompanyRate
                } else if (isOfficial) {
                    currencyRate = currencyOfficialRate
                }

                return {
                    rate: currencyRate ? (shortname === "UZS" ? (1 / currencyRate.rate).toFixed(l) : parseFloat(currencyRate.rate).toFixed(l)) : null,
                    range: currencyRate ? (shortname === "UZS" ? (-currencyRate.difference / (currencyRate.rate * (currencyRate.rate - currencyRate.difference))).toFixed(8) : parseFloat(currencyRate.difference).toFixed(l)) : null
                }
            }
        }
    },
    watch: {
        getUser: {
            deep: true,
            handler: function (newVal) {
                let date = new Date()
                date.toISOString().slice(0, 10)
                if (this.isAuthenticated) {
                    setTimeout(() => {
                        this
                            .fetchCompanyCurrencyRates({dateTime: date, id: newVal.person.company.id})
                            .then(() => {
                                this.$root.showOverlay = false
                            })
                    }, 2000)
                } else {
                    this.$root.showOverlay = false
                }
            }
        }
    }
}
